import React from "react";
import { Grid, SxProps } from "@mui/material";

export type ContainerPropsType = {
  columns: number[];
  children?: React.ReactNode;
  sx?: SxProps;
};

const SplitLayout = (props: ContainerPropsType) => {
  const { columns, sx } = props;
  return (
    <Grid
      sx={{ ...sx, minHeight: "5rem" }}
      container
      display={"flex"}
      columnSpacing={2}
    >
      {columns.map((col, i) => {
        return (
          <Grid
            key={i}
            item
            display={"flex"}
            justifyContent={"center"}
            flexDirection={"column"}
            md={col}
            lg={col}
          >
            {React.Children.toArray(props.children)[i]}
          </Grid>
        );
      })}
    </Grid>
  );
};

export default SplitLayout;
